import { Collapse, Grid } from "@mui/material";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import React, { useState } from "react";
import { useWatch } from "react-hook-form";
import AsynchronousAutocomplete from "../../../../components/Autocomplete/AsynchronousAutocomplete";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { FormAsyncPreDiningArrangement } from "../../../../components/Forms/Arrangements/FormAsyncPreDiningArrangement";

function Arrangements() {
  const enabled = useWatch({ name: "use_arrangements" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ display: "flex", flexWrap: "wrap" }}>
          <Grid item xs={12}>
            <h3>
              <TranslationWrapper tKey={"Arrangements"} />
            </h3>
          </Grid>
          <FormSwitchTC name={"use_arrangements"} tDefault={"Use arrangements"} tKey={"Use arrangements"} />
        </CardBody>
      </Card>
      <Collapse in={enabled} mountOnEnter unmountOnExit>
        <Card sx={{ mt: 2 }}>
          <CardBody>
            <h4>
              <TranslationWrapper tKey={"Options"} />
            </h4>
            <FormSwitchTC
              name={"extra_settings__arrangement_demo"}
              tDefault={"Demonstration mode"}
              tKey={"salesarea.arrangements.options.use_demo"}
              tooltip={
                <TranslationWrapper
                  tDefault={
                    "Configure this option if you want to use this salesarea to test or demo the arrangements application"
                  }
                  tKey={"tooltips.arrangements.options.use_demo"}
                />
              }
            />
            <FormAsyncPreDiningArrangement name={"extra_settings__pre_dining_arrangement_id"} />
          </CardBody>
        </Card>
      </Collapse>
    </div>
  );
}

export default Arrangements;
